import { randomBytes, createHash } from "node:crypto";

export interface PkcePair {
  codeVerifier: string;
  codeChallenge: string;
  state: string;
  nonce: string;
}

function base64Url(buf: Buffer): string {
  return buf.toString("base64url");
}

export function generatePkce(): PkcePair {
  const codeVerifier = base64Url(randomBytes(32));
  const codeChallenge = base64Url(createHash("sha256").update(codeVerifier).digest());
  const state = `state_${base64Url(randomBytes(16))}`;
  const nonce = `nonce_${base64Url(randomBytes(16))}`;
  return { codeVerifier, codeChallenge, state, nonce };
}
